import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import {
  RankingCategoryItem,
  ViewDataService,
  WCupRankingCategoryListLocator,
  WCupRankingLocator,
  WCupSeasonItem,
  WCupSeasonLocator
} from 'world-archery-lib';
import { FiltersAmateursRankingService } from '../filters-amateurs-ranking.service';

@Component({
  selector: 'app-series-amateur-ranking-filters',
  templateUrl: './series-amateur-ranking-filters.component.html',
  styleUrls: ['./series-amateur-ranking-filters.component.css']
})
export class SeriesAmateurRankingFiltersComponent {
  constructor(
    protected views: ViewDataService,
    public filter_service: FiltersAmateursRankingService
  ) { }

}
